/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * DashBoard
 * OpenAPI spec version: v2.0.0
 */

export type CsvDataType = (typeof CsvDataType)[keyof typeof CsvDataType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CsvDataType = {
  String: 'String',
  Int: 'Int',
  Double: 'Double',
  Bool: 'Bool',
  DateTime: 'DateTime',
} as const;
